<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Form -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Form :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="formId" name="formId"
                                    label="text"
                                    @input="changeFormMaster"
                                    :options="formIdArr" :clearable=false placeholder="Select Form">
                                </v-select>
                                <div class="help is-danger">{{formIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Department -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changedValueDepartment"
                                    :options="departmentArr" :clearable=false placeholder="Select Department">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <template v-if="locationDropDownShow">
                            <!-- Location -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="location" name="location"
                                        multiple
                                        label="name"
                                        @input="locationError = ''"
                                        placeholder="Select Location"
                                        :options="locationArr" :clearable=false>
                                    </v-select>
                                    <div class="help is-danger">{{locationError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                        </template>
                        <!-- To Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">To Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <vue-tags-input
                                    v-model="toEmail"
                                    :tags="toEmailTagsArr"
                                    :validation="validation"
                                    @tags-changed="newTags => toEmailTagsArr = newTags"
                                    @before-adding-tag="checkToEmailTag"
                                    placeholder=""
                                />
                                <div class="help is-danger">{{toEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- CC Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">CC Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <input type="text" maxlength="190" class="form-control" v-model="ccEmail" id="ccEmail" placeholder="Enter CC Email" name="ccEmail"> -->
                                <!--<input @input="emailError = ''" id="email" v-model="email" class="form-control" type="text"/>-->
                                <vue-tags-input
                                    v-model="ccEmail"
                                    :tags="ccEmailTagsArr"
                                    :validation="validation"
                                    @tags-changed="newTags => ccEmailTagsArr = newTags"
                                    @before-adding-tag="checkCCEmailTag"
                                    placeholder=""
                                />
                                <div class="help is-danger">{{ccEmailError}}</div>
                                <!-- <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <template v-if="locationDropDownShow">
                            <div class="col-6 forms-block">
                            </div>
                        </template>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addFormMapperData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addFormMapperData('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    import VueTagsInput from '@johmun/vue-tags-input';

    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateFormEmailManager',
        mixins: [commonMixins],
        components: {
            VueTagsInput,
        },
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Form Email Manager',
                edit_id: 0,
                toEmail:"",
                ccEmail: "",
                toEmailTagsArr:[],
                ccEmailTagsArr: [],
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                isValidToEmailTag :true,
                isValidCCEmailTag : true,
                toEmailError:"",
                ccEmailError: "",
                departmentArr: [ 
                    {
                        text: 'Call Center',
                        value: 'Call Center',
                    },
                    {
                        text: 'Central Ops',
                        value: 'Central Ops',
                    },
                    {
                        text: 'Parts',
                        value: 'Parts',
                    },
                ],
                departmentId: "",
                departmentIdError: "",
                location: [],
                locationArr: [],
                locationError: "",
                formId: "",
                formIdArr: [],
                formIdError: "",

                managerEmail: "",
                loginUserRoleId: 1,
                partsDepartmentLocationArr: [],
                locationDropDownShow: true,
            }
        },
        watch: {
            formId: function(formId) {
                // self.changeFormValue(formId.value);
            }
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.loadFormMasterData();
            self.menuActive("ListFormEmailManager");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Form Email Manager';
                    self.getFormMapperDataById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                }
            });
            self.loadLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/form/email/manager/list');
            },
            changeFormValue: function (id) {
                if (id != null && id != "" && typeof id != "undefined") {
                    let idArray = [];
                    var editId = 0;
                    if (self.$route.params.id != null && self.$route.params.id != "" && typeof (self.$route.params.id) != "undefined") {
                        editId = self.$route.params.id;
                    }
                    for (let i = 0; i < id.length; i++) {
                        idArray.push(id[i].value)
                    }
                    var config = {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tkn")
                        },
                        params: {
                            edit_id: editId,
                            form_key_id: id
                        }
                    };
                    HTTP.get('/formemailmanager/check', config)
                        .then(response => {
                            if (response.data.status == "Success") {
                                self.disableButtons.save = true;
                                self.$swal({
                                    type : "error",
                                    text: response.data.message,
                                    confirmButtonColor: '#3085d6',
                                    confirmButtonText: 'Ok',
                                });
                            } else {
                                self.disableButtons.save = false;
                            }
                        })
                        .catch(function (err) {
                            /* console.log(err); */
                            self.catchHandler(err, function () {});
                        });
                }
            },
            checkToEmailTag: function(obj) {
                self.toEmailError = "";
                self.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            checkCCEmailTag: function(obj) {
                self.ccEmailError = "";
                self.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            changedValueDepartment: function(department) {
                self.departmentIdError = "";
                self.locationArr = [];
                self.location = [];
                self.locationDropDownShow = true;
                if (department != 'undefined' && department.value) {
                    self.locationArr = self.partsDepartmentLocationArr;
                    if(department.value != 'Parts') {
                        self.locationDropDownShow = false;
                        // self.locationArr = self.bodyShopLocationArr;
                    }
                }
            },
            getFormMapperDataById: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        id: self.edit_id,
                    }
                };
                self.showLoader();
                HTTP.get("/form/mapper/get", config)
                        .then(function (response) {
                            self.formId = {text: response.data.content.formName, value: response.data.content.form_id};
                            self.departmentId = {text: response.data.content.department, value: response.data.content.department};
                            setTimeout(function() {
                                self.location.push({"name": response.data.content.locationName, "id": response.data.content.location_id});
                                // self.location = response.data.content.locationArr;
                            }, 50);
                            if(response.data.content.cc_email && response.data.content.cc_email != 'NULL') {
                                var ccEmailArr = response.data.content.cc_email.split(",");
                                for(var index = 0; index < ccEmailArr.length; index++) {
                                    self.ccEmailTagsArr.push({"text": ccEmailArr[index], "tiClasses": ["ti-valid"]});
                                }
                            }
                            if(response.data.content.to_email && response.data.content.to_email != 'NULL') {
                                var toEmailArr = response.data.content.to_email.split(",");
                                for(var index = 0; index < toEmailArr.length; index++) {
                                    self.toEmailTagsArr.push({"text": toEmailArr[index], "tiClasses": ["ti-valid"]});
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadFormMasterData: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.get("/form/manager/get", config)
                    .then(function (response) {
                        self.formIdArr = response.data.content;
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            changeFormMaster: function(formMaster) {
                self.formIdArrError = "";
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: 1
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.partsDepartmentLocationArr = response.data.locations;
                            if(self.partsDepartmentLocationArr && self.partsDepartmentLocationArr.length > 0) {
                                for(var index = 0; index < self.partsDepartmentLocationArr.length; index++) {
                                    var objLocation = self.partsDepartmentLocationArr[index];
                                    if(objLocation['name'] == 'BusWest - Woodland, CA' || objLocation['id'] == 37) {
                                        self.partsDepartmentLocationArr.splice(index, 1);
                                    }
                                }
                                for(var index = 0; index < self.partsDepartmentLocationArr.length; index++) {
                                    var objLocation = self.partsDepartmentLocationArr[index];
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - El Centro, CA" || objLocation['id'] == 39) {
                                        self.partsDepartmentLocationArr[index]['name'] = "El Centro, CA";
                                    }
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - Nogales, AZ" || objLocation['id'] == 33) {
                                        self.partsDepartmentLocationArr[index]['name'] = "Nogales, AZ";
                                    }
                                    if(objLocation['name'] == "Velocity Truck & Trailer Parts - San Diego, CA" || objLocation['id'] == 40) {
                                        self.partsDepartmentLocationArr[index]['name'] = "OTAY";
                                    }
                                }
                                var objOntario = {
                                    "name": "ONTARIO",
                                    "id": 9992,
                                    "position": {
                                        "lat": '',
                                        "lng": ''
                                    },
                                    "is_buswest": false,
                                    "manager_email": "jsanchez@vvgtruck.com",
                                    "manager_name": "Jesse Sanchez"
                                };
                                self.partsDepartmentLocationArr.push(objOntario);
                            }
                            self.partsDepartmentLocationArr = self.partsDepartmentLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            // console.log(self.partsDepartmentLocationArr.length);
                            // console.log(JSON.stringify(self.partsDepartmentLocationArr));
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.locationError = "";
                self.departmentIdError = "";
                self.toEmailError = "";
                self.ccEmailError = "";
                self.formIdError = "";
                self.isValidCCEmailTag = true;

                if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "Select Department";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.locationDropDownShow) {
                    if (self.location.length == 0) {
                        self.locationError = "select Location";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.formId == null || !self.formId.value) {
                    self.formIdError = "select Form";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.toEmailTagsArr.length == 0) {
                    self.isValidToEmailTag = false;
                    self.toEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (self.ccEmailTagsArr.length == 0) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },
            addFormMapperData(flag) {
                setTimeout(() => {
                    if (self.isValidCCEmailTag && self.isValidToEmailTag && self.checkForm()) {
                        var toEmailData = "";
                        if(self.toEmailTagsArr && self.toEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.toEmailTagsArr.length;index++) {
                                if(!toEmailData.includes(self.toEmailTagsArr[index].text)) {
                                    toEmailData += (self.toEmailTagsArr[index].text) + ',';
                                }
                            }
                        }
                        toEmailData = toEmailData.replace(/,\s*$/, "");
                        var ccEmailData = "";
                        if(self.ccEmailTagsArr && self.ccEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.ccEmailTagsArr.length;index++) {
                                if(!ccEmailData.includes(self.ccEmailTagsArr[index].text)) {
                                    ccEmailData += (self.ccEmailTagsArr[index].text) + ',';
                                }
                            }
                        }
                        ccEmailData = ccEmailData.replace(/,\s*$/, "");
                        var strLocationId = "";
                        if(self.locationDropDownShow) {
                            if(self.location && self.location.length > 0) {
                                for(var index = 0; index < self.location.length; index++) {
                                    var obj = self.location[index];
                                    strLocationId += obj['id'] + ",";
                                }
                                strLocationId = strLocationId.replace(/,\s*$/, "");
                            }
                        }
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var fields = {
                            id: self.edit_id,
                            manager_email: self.managerEmail,
                            form_id: self.formId.value,
                            departmentName: self.departmentId.value,
                            location: strLocationId,
                            to_email: toEmailData,
                            cc_email: ccEmailData,
                        };
                        self.showLoader();
                        HTTP.post("/form/mapper/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                self.edit_id = 0;
                self.managerEmail = '';
                self.departmentId = '';
                self.locationDropDownShow = true;
                self.location = [];
                self.formId = '';
                self.toEmail = '';
                self.ccEmail = '';
                self.toEmailTagsArr = [];
                self.ccEmailTagsArr = [];
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/FormEmailManager/AddUpdateFormEmailManager.vue